import { Box } from '@mui/material'
import { useEffect, useRef } from 'react'

function ScrollToElement() {
  const elementRef = useRef<HTMLDivElement | null>(null)
  useEffect(() => {
    elementRef.current?.scrollIntoView()
  })
  return <Box ref={elementRef} />
}

export default ScrollToElement
